<template>
  <div>
    <div class="modal-content">
      <div class="modal-header d-flex align-items-center">
        <div class="modal-title h4">{{ title || '' }}</div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cancel">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <Viewer
          class="markdown-viewer"
          :initialValue="content"
        ></Viewer>
      </div>
    </div>
  </div>
</template>

<script>
  import { Viewer } from '@toast-ui/vue-editor';

  export default {
    components: {
      Viewer
    },
    props: {
      content: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: false
      }
    },
    methods: {
      cancel: function () {
        this.$emit('close');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modal-body {
    max-height: 500px;
    overflow: auto;
  }
</style>
